import { combineReducers } from "redux";
import userLoginSlice from "../../container/Login/slice/userLoginSlice";
import userSlice from "../../container/Login/slice/userSlice";
import HeaderSlice from "../../container/Header/headerSlice";

const mainReducer = combineReducers({
    userState: userSlice,
    userLoginSlice: userLoginSlice,
    headerState: HeaderSlice,
});

const rootReducer = (state, action) => {
    if (action.type === "CLEAR_STORE") {
        // Reset each slice state to its initial state
        state = undefined;
    }
    return mainReducer(state, action);
};

export default rootReducer;